/**
 * BuddyGroupMemberList — renders a list of members in a buddy group.
 */

import { Badge } from '@/components/ui/badge';
import type { BuddyGroupMemberView } from '../types/buddy-group';

interface BuddyGroupMemberListProps {
  members: BuddyGroupMemberView[];
}

export function BuddyGroupMemberList({ members }: BuddyGroupMemberListProps) {
  if (members.length === 0) {
    return <p className="text-sm text-muted-foreground italic">No members</p>;
  }

  return (
    <ul className="divide-y divide-border">
      {members.map((member) => (
        <li key={member.id} className="flex items-center justify-between py-3 px-1">
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium">{member.display_name}</span>
            {member.is_primary && (
              <Badge variant="secondary" className="text-xs">Primary</Badge>
            )}
          </div>
          <div className="flex items-center gap-3 text-xs text-muted-foreground">
            {member.member_number && <span>#{member.member_number}</span>}
          </div>
        </li>
      ))}
    </ul>
  );
}
